"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
function frFlag(_a) {
    var size = _a.size;
    return React.createElement("svg", { width: size / 30 * 38, height: size, viewBox: "0 0 38 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { filter: "url(#filter0_d)" },
            React.createElement("mask", { id: "mask0", "mask-type": "alpha", maskUnits: "userSpaceOnUse", x: 3, y: 1, width: 32, height: 24 },
                React.createElement("rect", { x: 3, y: 1, width: 32, height: 24, fill: "white" })),
            React.createElement("g", { mask: "url(#mask0)" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M25 1H35V25H25V1Z", fill: "#F50100" }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 1H15V25H3V1Z", fill: "#2E42A5" }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 1H25V25H13V1Z", fill: "#F7FCFF" })),
            React.createElement("rect", { x: 3, y: 1, width: 32, height: 24, fill: "url(#paint0_linear)", style: {
                    mixBlendMode: "overlay"
                } }),
            React.createElement("path", { d: "M5 2H33V0H5V2ZM34 3V23H36V3H34ZM33 24H5V26H33V24ZM4 23V3H2V23H4ZM5 24C4.44772 24 4 23.5523 4 23H2C2 24.6569 3.34315 26 5 26V24ZM34 23C34 23.5523 33.5523 24 33 24V26C34.6569 26 36 24.6569 36 23H34ZM33 2C33.5523 2 34 2.44772 34 3H36C36 1.34315 34.6569 0 33 0V2ZM5 0C3.34315 0 2 1.34314 2 3H4C4 2.44772 4.44771 2 5 2V0Z", fill: "black", fillOpacity: 0.1, style: {
                    mixBlendMode: "multiply"
                } })),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d", x: 0, y: 0, width: 38, height: 30, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { "in": "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                React.createElement("feOffset", { dy: 2 }),
                React.createElement("feGaussianBlur", { stdDeviation: 1.5 }),
                React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
                React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
                React.createElement("feBlend", { mode: "normal", "in": "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })),
            React.createElement("linearGradient", { id: "paint0_linear", x1: 19, y1: 1, x2: 19, y2: 25, gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "white", stopOpacity: 0.7 }),
                React.createElement("stop", { offset: 1, stopOpacity: 0.3 }))));
}
exports["default"] = frFlag;
//# sourceMappingURL=frFlag.js.map